import React, { useEffect, useState } from 'react';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBSwitch,
} from 'mdbreact';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import api from '../../../../services/api';
import resolverMensagemErro from '../../../../utils/resolverMensagemErro';
import Loading from '../../../../components/Loading';
import NavBar from '../../../../components/NavBar';

// Gestao dos BDTs em ABERTO (data_dispensa = null): visualizar, editar
// (KM inicial, excecao/justificativa) e dispensar (fechar) o boletim.
export default function BdtsAbertos() {
  const [loading, setLoading] = useState(false);
  const [lista, setLista] = useState([]);

  // detalhe/edicao
  const [detalhe, setDetalhe] = useState(null); // BDT completo (via /bdts?id=)
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false);
  const [salvando, setSalvando] = useState(false);

  // campos editaveis
  const [kmInicial, setKmInicial] = useState('');
  const [excessao, setExcessao] = useState(false);
  const [excessaoJust, setExcessaoJust] = useState('');
  const [kmFim, setKmFim] = useState('');
  // encerrar SEM KM final: exige justificativa via modal
  const [modalSemKm, setModalSemKm] = useState(false);
  const [kmJustificativa, setKmJustificativa] = useState('');

  const dataHora = valor => {
    if (!valor) return '';
    try {
      return format(new Date(valor), 'dd/MM/yyyy HH:mm');
    } catch (e) {
      return '';
    }
  };

  const carregar = async () => {
    setLoading(true);
    try {
      const result = await api.get('/bdts-listar', {
        params: { dispensaAberta: 'true' },
      });
      setLista(Array.isArray(result.data) ? result.data : []);
    } catch (e) {
      toast.error('Falha ao carregar os BDTs em aberto');
    }
    setLoading(false);
  };

  useEffect(() => {
    carregar();
  }, []);

  // abre a modal e carrega o BDT completo (com ocorrencias/abastecimentos)
  const abrirDetalhe = async id => {
    setCarregandoDetalhe(true);
    setDetalhe({ id }); // abre a modal ja
    try {
      const result = await api.get('/bdts', { params: { id } });
      const bdt = result.data;
      // #116: BDT inexistente virou 404 e cai no catch; aqui sobra o corpo
      // vazio, que o backend ainda pode devolver.
      if (!bdt) {
        toast.error('BDT não encontrado');
        setDetalhe(null);
        return;
      }
      setDetalhe(bdt);
      setKmInicial(bdt.quilometragem_inicio ?? '');
      setExcessao(bdt.excessao === true);
      setExcessaoJust(bdt.excessao_justificativa || '');
      setKmFim('');
    } catch (e) {
      toast.error(resolverMensagemErro(e));
      setDetalhe(null);
    }
    setCarregandoDetalhe(false);
  };

  const fecharDetalhe = () => {
    setDetalhe(null);
  };

  // salva as edicoes (sem dispensar)
  const salvarEdicao = async () => {
    if (!detalhe) return;
    setSalvando(true);
    try {
      const payload = {
        quilometragem_inicio:
          kmInicial === '' ? null : Number(kmInicial),
        excessao,
        excessao_justificativa: excessao ? excessaoJust : null,
      };
      const result = await api.put(`/bdts/${detalhe.id}`, payload);
      if (result.data && result.data.erro) {
        toast.error(result.data.erro);
      } else {
        toast.success('BDT atualizado');
        fecharDetalhe();
        carregar();
      }
    } catch (e) {
      toast.error('Falha ao salvar');
    }
    setSalvando(false);
  };

  const dispensar = async (justificativa = null) => {
    if (!detalhe) return;
    if (kmFim === '' && !justificativa) {
      // sem KM final: encerramento exige justificativa (modal)
      setKmJustificativa('');
      setModalSemKm(true);
      return;
    }
    setSalvando(true);
    try {
      const payload = {
        quilometragem_inicio:
          kmInicial === '' ? null : Number(kmInicial),
        excessao,
        excessao_justificativa: excessao ? excessaoJust : null,
        dispensar: true,
        quilometragem_fim: kmFim === '' ? null : Number(kmFim),
        km_fim_justificativa: kmFim === '' ? justificativa : null,
      };
      const result = await api.put(`/bdts/${detalhe.id}`, payload);
      if (result.data && result.data.erro) {
        toast.error(result.data.erro);
      } else {
        toast.success('BDT dispensado (encerrado)');
        setModalSemKm(false);
        fecharDetalhe();
        carregar();
      }
    } catch (e) {
      toast.error(
        e?.response?.data?.erro || 'Falha ao dispensar o BDT'
      );
    }
    setSalvando(false);
  };

  return (
    <NavBar>
      <MDBContainer>
        <MDBRow className="h4-responsive mt-3" center>
          BDTs em Aberto
        </MDBRow>
        <MDBRow center className="mb-2">
          <MDBBtn size="sm" color="mdb-color" onClick={carregar}>
            <MDBIcon icon="sync" className="mr-2" />
            Atualizar
          </MDBBtn>
        </MDBRow>

        {loading ? (
          <Loading />
        ) : lista.length === 0 ? (
          <MDBRow
            center
            className="mt-3 h5-responsive text-danger font-weight-bolder"
          >
            Nenhum BDT em aberto.
          </MDBRow>
        ) : (
          lista.map(bdt => (
            <MDBCard className="my-3" key={`bdt${bdt.id}`}>
              <MDBCardBody>
                <MDBRow className="align-items-center">
                  <MDBCol size="12" md="3">
                    <b>Viatura:</b>
                    <br />
                    {bdt.veiculo ? bdt.veiculo.placa : '—'}
                    {bdt.veiculo && bdt.veiculo.modelo
                      ? ` (${bdt.veiculo.modelo})`
                      : ''}
                  </MDBCol>
                  <MDBCol size="12" md="3">
                    <b>Apresentação:</b>
                    <br />
                    {dataHora(bdt.data_apresentacao)}
                  </MDBCol>
                  <MDBCol size="12" md="2">
                    <b>KM Inicial:</b>
                    <br />
                    {bdt.quilometragem_inicio}
                  </MDBCol>
                  <MDBCol size="12" md="2">
                    <b>Exceção:</b>
                    <br />
                    {bdt.excessao === true ? 'Sim' : 'Não'}
                  </MDBCol>
                  <MDBCol
                    size="12"
                    md="2"
                    className="text-md-right mt-2 mt-md-0"
                  >
                    <MDBBtn
                      size="sm"
                      color="info"
                      onClick={() => abrirDetalhe(bdt.id)}
                    >
                      <MDBIcon far icon="edit" className="mr-1" />
                      Ver/Editar
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
          ))
        )}

        {/* MODAL VER/EDITAR/DISPENSAR */}
        <MDBModal
          size="lg"
          isOpen={detalhe !== null}
          toggle={fecharDetalhe}
        >
          <MDBModalHeader toggle={fecharDetalhe}>
            BDT {detalhe ? `#${detalhe.id}` : ''}
          </MDBModalHeader>
          <MDBModalBody>
            {carregandoDetalhe ? (
              <Loading />
            ) : detalhe ? (
              <>
                <MDBRow>
                  <MDBCol size="12" md="6">
                    <b>Viatura:</b>{' '}
                    {detalhe.veiculo ? detalhe.veiculo.placa : '—'}
                  </MDBCol>
                  <MDBCol size="12" md="6">
                    <b>Agente:</b>{' '}
                    {detalhe.usuario ? detalhe.usuario.nome_social : '—'}
                  </MDBCol>
                </MDBRow>
                <MDBRow className="mt-1">
                  <MDBCol size="12" md="6">
                    <b>Apresentação:</b> {dataHora(detalhe.data_apresentacao)}
                  </MDBCol>
                  <MDBCol size="12" md="6">
                    <b>Dispensa:</b>{' '}
                    {detalhe.data_dispensa ? (
                      dataHora(detalhe.data_dispensa)
                    ) : (
                      <span className="text-danger font-weight-bolder">
                        EM ABERTO
                      </span>
                    )}
                  </MDBCol>
                </MDBRow>

                <hr />
                <p className="font-weight-bold mb-2">Editar</p>

                <MDBRow>
                  <MDBCol size="12" md="6">
                    <MDBInput
                      label="KM Inicial"
                      type="number"
                      value={String(kmInicial)}
                      onChange={e => setKmInicial(e.target.value)}
                    />
                  </MDBCol>
                  <MDBCol size="12" md="6" className="mt-3">
                    <MDBSwitch
                      labelLeft="Exceção"
                      labelRight=""
                      checked={excessao}
                      onChange={() => setExcessao(!excessao)}
                    />
                  </MDBCol>
                </MDBRow>
                {excessao && (
                  <MDBRow>
                    <MDBCol size="12">
                      <MDBInput
                        type="textarea"
                        label="Justificativa da exceção"
                        rows="2"
                        value={excessaoJust}
                        onChange={e => setExcessaoJust(e.target.value)}
                      />
                    </MDBCol>
                  </MDBRow>
                )}

                <hr />
                <p className="font-weight-bold mb-2 text-danger">
                  Dispensar (encerrar) o BDT
                </p>
                <MDBRow className="align-items-center">
                  <MDBCol size="12" md="6">
                    <MDBInput
                      label="KM Final (para dispensar)"
                      type="number"
                      value={String(kmFim)}
                      onChange={e => setKmFim(e.target.value)}
                    />
                  </MDBCol>
                  <MDBCol size="12" md="6">
                    <MDBBtn
                      color="warning"
                      size="sm"
                      disabled={salvando}
                      onClick={() => dispensar()}
                    >
                      <MDBIcon icon="flag-checkered" className="mr-2" />
                      Dispensar BDT
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>

                {/* resumo de ocorrencias / abastecimentos (leitura) */}
                {detalhe.bdts_ocorrencias &&
                  detalhe.bdts_ocorrencias.length > 0 && (
                    <>
                      <hr />
                      <p className="font-weight-bold mb-1">Ocorrências</p>
                      {detalhe.bdts_ocorrencias.map(oco => (
                        <div key={`oc${oco.id}`} className="mb-1">
                          {oco.tipo_bdts_ocorrencia
                            ? oco.tipo_bdts_ocorrencia.tipo_ocorrencia
                            : ''}
                          : {oco.descricao}
                        </div>
                      ))}
                    </>
                  )}
                {detalhe.abastecimentos &&
                  detalhe.abastecimentos.length > 0 && (
                    <>
                      <hr />
                      <p className="font-weight-bold mb-1">Abastecimentos</p>
                      {detalhe.abastecimentos.map(ab => (
                        <div key={`ab${ab.id}`} className="mb-1">
                          {dataHora(ab.data_abastecimento)} —{' '}
                          {ab.tipos_combustivei
                            ? ab.tipos_combustivei.tipo_combustivel
                            : ''}{' '}
                          — {ab.quantidade}L — KM {ab.quilometragem} — R${' '}
                          {ab.valor_total}
                        </div>
                      ))}
                    </>
                  )}
              </>
            ) : null}
          </MDBModalBody>
          <MDBModalFooter between>
            <MDBBtn color="danger" size="sm" onClick={fecharDetalhe}>
              Fechar
            </MDBBtn>
            <MDBBtn
              color="success"
              size="sm"
              disabled={salvando || carregandoDetalhe}
              onClick={salvarEdicao}
            >
              <MDBIcon icon="save" className="mr-2" />
              Salvar
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        {/* justificativa obrigatoria p/ encerrar SEM a quilometragem final */}
        <MDBModal isOpen={modalSemKm} toggle={() => {}} centered>
          <MDBModalHeader>Encerrar sem quilometragem</MDBModalHeader>
          <MDBModalBody>
            <p>
              Você está encerrando o BDT sem informar a quilometragem final.
              Justifique:
            </p>
            <MDBInput
              type="textarea"
              rows="3"
              label="Justificativa"
              value={kmJustificativa}
              onChange={e => setKmJustificativa(e.target.value)}
            />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              color="secondary"
              size="sm"
              onClick={() => setModalSemKm(false)}
            >
              Cancelar
            </MDBBtn>
            <MDBBtn
              color="warning"
              size="sm"
              disabled={salvando}
              onClick={() => {
                if (!kmJustificativa.trim()) {
                  toast.error('Informe a justificativa.');
                  return;
                }
                dispensar(kmJustificativa.trim());
              }}
            >
              Encerrar sem KM
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </NavBar>
  );
}
